var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgupload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1999 2.79996H3.9999C3.11625 2.79996 2.3999 3.5163 2.3999 4.39996V15.6C2.3999 16.4836 3.11625 17.2 3.9999 17.2H15.1999C16.0836 17.2 16.7999 16.4836 16.7999 15.6V4.39996C16.7999 3.5163 16.0836 2.79996 15.1999 2.79996Z",
    stroke: "#845BB3",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6001 6.79996V13.2",
    stroke: "#845BB3",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3999 9.99997H12.7999",
    stroke: "#845BB3",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgupload);
export default __webpack_public_path__ + "static/media/imgupload.5130eb5027505f911d5dd1d49f58fbfc.svg";
export { ForwardRef as ReactComponent };